import type { IconData } from '@stacksjs/iconify-core'

export const beautyBodyCareSunScreen: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6.1 0v7.62h1.53v7.62h1.52v-1.52h1.52v1.52H9.145v9.14h1.52v-1.52h10.67v1.52h1.52v-9.14h-1.52v-1.52h1.52v1.52h1.53V7.62h1.52V0Zm10.67 1.53h3.05v1.52h-3.05Zm-4.57 0h3.05v1.52H12.2Zm-4.57 0h3.04v1.52H7.625Zm4.57 18.28h-1.53v-1.52h1.53Zm-1.53-9.14V9.15h1.53v1.52Zm6.1 10.67h-1.52v-1.53h1.52Zm1.52-3.05h-4.57v-1.52H12.2v-4.58h1.52v-1.52h4.57v1.52h1.53v4.58h-1.53Zm-3.04-9.14V7.62h1.52v1.53Zm6.09 10.66h-1.52v-1.52h1.52Zm0-9.14h-1.52V9.15h1.52Zm3.05-4.57H7.625V4.57h16.76Zm0-3.05h-3.05V1.53h3.05Z\"/><path fill=\"currentColor\" d=\"M10.665 24.38V32h10.67v-7.62Zm9.15 4.58h-1.53v1.52h-4.57v-1.52H12.2v-3.05h7.62Z\"/><path fill=\"currentColor\" d=\"M13.715 27.43h4.57v1.53h-4.57Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default beautyBodyCareSunScreen
